/* ============================================================
   ROSA ECK Wishlist – Client fuer den eigenen Wishlist-Worker
   (https://rosaeck-wishlist.rosaeck.workers.dev, Repo ~/Projekte/wishlist).
   Ersetzt die App Swish/Wishlist King (2026-09-18).

   - Gast-Identitaet: UUID-Token in localStorage, Header X-Wishlist-Token.
   - Buttons: [data-wishlist-button] (Snippet wishlist-button.liquid),
     Zustand .is-active + aria-pressed; Grid-Herz spielt beim Merken
     Pop + Strahlen (re-burst), beim Entmerken Dip (re-dip) – Keyframes
     in custom-re.css, Abschnitt "Wishlist".
   - Header: .wkh-counter (Zahl) + .wkh-selected auf .wkh-button;
     Anti-Flash-Zwischenstand in localStorage "rosa-wishlist-count"
     (liest das Inline-Script in sections/header.liquid).
   - Optimistisch: Zustand schaltet sofort, API folgt; bei Fehler Revert.
   ============================================================ */
(function () {
  "use strict";

  var API = window.ROSA_WISHLIST_API;
  if (!API) return;

  var TOKEN_KEY = "rosa-wishlist-token";
  var COUNT_KEY = "rosa-wishlist-count";
  var HANDLES_KEY = "rosa-wishlist-handles";
  var HINT_KEY = "rosa-wishlist-hint";

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    // Fallback fuer aeltere Safaris (randomUUID ab iOS 15.4)
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === "x" ? r : (r & 3) | 8).toString(16);
    });
  }

  var memToken = null;
  function token() {
    if (memToken) return memToken;
    try {
      memToken = localStorage.getItem(TOKEN_KEY);
      if (!memToken) {
        memToken = uuid();
        localStorage.setItem(TOKEN_KEY, memToken);
      }
    } catch (e) {
      memToken = memToken || uuid();
    }
    return memToken;
  }

  function request(method, path, body) {
    return fetch(API + path, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        "X-Wishlist-Token": token()
      },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (res) {
      if (!res.ok) throw new Error("wishlist api " + res.status);
      return res.json();
    });
  }

  var handles = null;   // Array der gemerkten Produkt-Handles
  var loading = null;
  var mutSeq = 0;       // zaehlt Toggles, damit ein spaeter eintreffender
                        // Server-Stand keine frische Aenderung ueberschreibt

  function fetchList() {
    var seqAtStart = mutSeq;
    return request("GET", "/api/wishlist").then(function (data) {
      if (mutSeq === seqAtStart) {
        handles = data.items.map(function (i) { return i.product_handle; });
      }
      return handles;
    });
  }

  function load() {
    if (handles) return Promise.resolve(handles);
    if (loading) return loading;
    loading = fetchList().then(function (h) {
      loading = null;
      return h;
    }).catch(function (e) {
      loading = null;
      throw e;
    });
    return loading;
  }

  function has(handle) {
    return !!handles && handles.indexOf(handle) !== -1;
  }

  function paintButton(btn) {
    var active = has(btn.dataset.productHandle);
    btn.classList.toggle("is-active", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
  }

  function paintAll(root) {
    // Prepaint-CSS aus theme.liquid entfernen: ab jetzt gelten die Klassen
    var pre = document.getElementById("re-wl-prepaint");
    if (pre) pre.remove();
    (root || document).querySelectorAll("[data-wishlist-button]").forEach(paintButton);
    var n = handles ? handles.length : 0;
    try {
      localStorage.setItem(COUNT_KEY, String(n));
      localStorage.setItem(HANDLES_KEY, JSON.stringify(handles || []));
    } catch (e) { /* egal */ }
    document.querySelectorAll(".wishlist-header-link .wkh-button").forEach(function (link) {
      link.classList.toggle("wkh-selected", n > 0);
      var c = link.querySelector(".wkh-counter");
      if (c) c.textContent = n;
    });
    document.querySelectorAll("[data-wishlist-count]").forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.dispatchEvent(new CustomEvent("rosa:wishlist:change", { detail: { handles: handles || [] } }));
  }

  /* Pop/Dip wie beim Swish-Herz: Klassen auf dem Wrapper (.re-wl),
     Pop laeuft auf dem inneren Button, Strahlen auf dem ::after des
     Wrappers. Entfernt wird per animationend (fruehes Entfernen
     hackte den Pop mittendrin ab – gleiche Lehre wie bei Swish). */
  function playAnim(btn, cls) {
    var wrap = btn.closest(".re-wl") || btn;
    wrap.classList.remove("re-burst", "re-dip");
    void wrap.offsetWidth;
    wrap.classList.add(cls);
  }

  document.addEventListener("animationend", function (e) {
    var wrap = e.target && e.target.closest ? e.target.closest(".re-wl") : null;
    if (!wrap) return;
    if (e.animationName === "re-wk-rays") wrap.classList.remove("re-burst");
    else if (e.animationName === "re-wk-dip") wrap.classList.remove("re-dip");
  }, true);

  /* Einmaliger Hinweis beim allerersten Merken (nicht auf der Wunschlisten-
     Seite selbst): kleiner Toast im Tropfen-Look, verschwindet von selbst,
     fuehrt per Tipp zur Wunschliste. Danach nie wieder (localStorage-Flag). */
  function maybeShowHint() {
    if (location.pathname.indexOf("/pages/wunschliste") === 0) return;
    try {
      if (localStorage.getItem(HINT_KEY)) return;
      localStorage.setItem(HINT_KEY, "1");
    } catch (e) { return; }
    /* Unten ist Standard; liegt dort gerade etwas Fixes (Cookie-Banner,
       Preview-Leiste), weicht der Toast nach oben unter den Header aus. */
    var bottomBlocked = false;
    try {
      var vh = window.innerHeight;
      var kids = document.body.children;
      for (var i = 0; i < kids.length; i++) {
        var cs = getComputedStyle(kids[i]);
        if (cs.position !== "fixed" && cs.position !== "sticky") continue;
        if (cs.display === "none" || cs.visibility === "hidden" || parseFloat(cs.opacity || "1") === 0) continue;
        var r = kids[i].getBoundingClientRect();
        if (r.height > 30 && r.width > 200 && r.bottom > vh - 120 && r.top > vh * 0.5) { bottomBlocked = true; break; }
      }
    } catch (e) { /* im Zweifel unten */ }
    var t = document.createElement("a");
    t.className = "re-wl-hint" + (bottomBlocked ? " re-wl-hint--top" : "");
    t.href = "/pages/wunschliste";
    t.setAttribute("role", "status");
    t.innerHTML = 'Gemerkt <svg class="re-wl-hint__heart" viewBox="0 0 1280 1000" aria-hidden="true"><path fill="#FF80FF" d="M791 0L640 235L489 0L215 0L0 390L640 1000L1280 390L1065 0L791 0z"/></svg> Deine Wunschliste kannst du mit Familie und Freunden teilen.<span class="re-wl-hint__link">Zur Wunschliste</span>';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("is-visible"); });
    setTimeout(function () {
      t.classList.remove("is-visible");
      setTimeout(function () { t.remove(); }, 300);
    }, 6000);
  }

  function toggle(handle, variantId, btn, reason) {
    return load().then(function () {
      mutSeq++;
      var adding = !has(handle);
      if (adding) handles.push(handle);
      else handles = handles.filter(function (h) { return h !== handle; });
      if (btn) playAnim(btn, adding ? "re-burst" : "re-dip");
      if (adding && btn) maybeShowHint();
      paintAll();
      // reason 'cart' = beim Uebernehmen in den Warenkorb entfernt (Auswertung)
      var call = adding
        ? request("POST", "/api/wishlist/items", { handle: handle, variantId: variantId || null })
        : request("DELETE", "/api/wishlist/items/" + encodeURIComponent(handle) + (reason === "cart" ? "?reason=cart" : ""));
      return call.catch(function (err) {
        // Revert bei API-Fehler
        if (adding) handles = handles.filter(function (h) { return h !== handle; });
        else handles.push(handle);
        paintAll();
        throw err;
      });
    });
  }

  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-wishlist-button]");
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(btn.dataset.productHandle, btn.dataset.variantId, btn).catch(function () { /* Revert lief bereits */ });
  }, true);

  /* Spaeter eingefuegte Karten (Zuletzt angesehen, Empfehlungen per API,
     Quick-Search) direkt mit Zustand versorgen. */
  var mo = new MutationObserver(function (muts) {
    if (!handles) return;
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches("[data-wishlist-button]")) paintButton(node);
        else if (node.querySelectorAll) node.querySelectorAll("[data-wishlist-button]").forEach(paintButton);
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  window.RosaWishlist = {
    load: load,
    toggle: toggle,
    refresh: function () {
      handles = null;
      return load().then(function () { paintAll(); });
    },
    token: token
  };

  function init() {
    try { localStorage.removeItem("re_wk_count"); } catch (e) { /* Swish-Altlast */ }
    /* Anti-Flash: Herzen sofort aus dem lokalen Cache malen (kein Warten auf
       die API); der frische Server-Stand gleicht danach nur noch ab. */
    try {
      var cached = JSON.parse(localStorage.getItem(HANDLES_KEY) || "null");
      if (Array.isArray(cached)) {
        handles = cached;
        paintAll();
      }
    } catch (e) { /* egal */ }
    fetchList().then(function () { paintAll(); }).catch(function () { /* offline: Cache-Stand bleibt */ });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
